<div class="tw-card  tw-shandow-black tw-shadow-2xl tw-rounded-2xl tw-p-4 md:tw-p-6 tw-mx-auto tw-w-full tw-max-w-lg md:tw-max-w-full hover:-tw-translate-y-3 tw-transition-all tw-duration-300 hover-tw-bg-[#F67011]"
    [ngClass]="{
      'tw-bg-[#F67011]': destacado,
      'tw-bg-white': !destacado
    }"
        (mouseenter)="destacado = true"
        (mouseleave)="destacado = false"
    >

    <!-- Encabezado con SVG -->
    <div class="tw-flex tw-items-start tw-justify-between tw-relative">
      <h3 class="tw-text-2xl md:tw-text-3xl tw-font-montserrat tw-font-bold tw-pr-4 tw-transition tw-duration-300"
        [ngClass]="{
          'tw-text-black': destacado,
          'tw-text-[#F67011]': !destacado
        }">
        Plan {{plan}}
      </h3>
      <img [src]="destacado ? 'assets/iconBlack.svg' : 'assets/icon.svg'" alt="icon"
           class="tw-w-8 sm:tw-w-8 md:tw-w-8 lg:tw-w-10 tw-absolute tw-right-0 tw-top-[-10px] tw-transition tw-duration-300" />
    </div>

    <!-- Divisor -->
    <div class="tw-border-t tw-border-solid tw-w-[80%] sm:tw-w-[80%] md:tw-w-[85%] tw-transition tw-duration-300"
      [ngClass]="{
        'tw-border-white': destacado,
        'tw-border-[#F67011]': !destacado
      }">
    </div>

    <!-- Lista de características -->
    <div class="tw-mt-3 md:tw-mt-4">
      <ul class="tw-list-disc tw-pl-5 tw-space-y-1 md:tw-space-y-2 tw-transition tw-duration-300">
        <li class="tw-font-montserrat tw-font-medium tw-text-xs md:tw-text-sm"
          [ngClass]="{
            'tw-text-white': destacado,
            'tw-text-gray-800': !destacado
          }">
          Velocidad hasta {{plan}} Mbps
        </li>
        <li class="tw-font-montserrat tw-font-medium tw-text-xs md:tw-text-sm"
          [ngClass]="{
            'tw-text-white': destacado,
            'tw-text-gray-800': !destacado
          }">
          Fibra óptica hasta la casa (FTTH)
        </li>
        <li class="tw-font-montserrat tw-font-medium tw-text-xs md:tw-text-sm"
        [ngClass]="{
          'tw-text-white': destacado,
          'tw-text-gray-800': !destacado
        }">
          {{text}}

        </li>
      </ul>


    </div>

    <!-- Precio - Sección mejorada -->
    <div class="tw-mt-3 md:tw-mt-4 tw-flex tw-items-baseline tw-gap-x-1 sm:tw-gap-x-2">
      <h2 class="tw-text-4xl xs:tw-text-5xl sm:tw-text-6xl md:tw-text-7xl tw-font-montserrat tw-font-bold tw-leading-none tw-transition tw-duration-300"
        [ngClass]="{
          'tw-text-white': destacado,
          'tw-text-[#F67011]': !destacado
        }">
        ${{price}}
      </h2>
      <h4 class="tw-text-base sm:tw-text-lg md:tw-text-xl tw-font-montserrat tw-font-bold tw-leading-none tw-whitespace-nowrap tw-transition tw-duration-300"
        [ngClass]="{
          'tw-text-white': destacado,
          'tw-text-[#F67011]': !destacado
        }">
        + IVA
      </h4>
    </div>

    <!-- Botón -->
    <div class="tw-mt-1 md:tw-mt-4 tw-flex tw-justify-center tw-items-center">
      <a target="_blank"
      [href]="whatsappLink"
      (click)="trackPlanSelection()"
      class=" tw-decoration-transparent tw-font-abadi tw-font-medium tw-px-4 tw-py-1 md:tw-px-6 md:tw-py-2 tw-rounded-full tw-transition-all tw-duration-300 tw-text-sm md:tw-text-base "
      [ngClass]="{
        'tw-bg-black tw-text-white hover:tw-bg-[#F67011]': destacado,
        'tw-bg-transparent tw-border tw-transition tw-duration-300 tw-border-[#F67011] tw-text-[#0000FF] hover:tw-bg-[#F67011] hover:tw-text-white hover:tw-border-[#F67011]': !destacado
      }">
      Lo quiero
    </a>

    </div>
</div>
